(ns frontend.view.settings2.surveys.components
  (:require
   [common.languages :as languages]
   [common.localization :as loc]
   [common.schema.entities.survey.mandatoriness-style :as mandatoriness-style]
   [common.schema.entities.survey.survey-reference-periods :as survey-reference-periods]
   [common.util :as cu]
   [frontend.view.settings2.surveys.events :as events]
   [re-frame.core :as rf]
   [ui.components.tab-strip.view :as tab-strip]
   [ui.editors.labelled-input.view :as labelled-input]))

(defn lang-selector
  [lang supported-languages]
  [tab-strip/view
   {:selected-tab lang
    :tabs         (->> supported-languages
                       (mapv (fn [l]
                               {:value l
                                :label (languages/get-label l)})))
    :on-change!   (fn [tab]
                    (rf/dispatch [::events/select-lang tab]))}])

(defn reference-period-selector
  [lang value]
  (let [options (survey-reference-periods/options lang)]
    [labelled-input/view
     {:data-type :data.type/keyword
      :value     (->> options
                      (cu/filter-by :value value)
                      (first))
      :label     (loc/tr :reference-period nil lang)
      :options   options
      :on-change (fn [v]
                   (rf/dispatch [::events/select-reference-period v]))}]))

(defn mandatoriness-style
  [lang value]
  (let [options (mandatoriness-style/options lang)]
    [labelled-input/view
     {:data-type :data.type/keyword
      :value     (->> options
                      (cu/filter-by :value value)
                      (first))
      :label     (loc/tr :mandatoriness-style)
      :options   options
      :on-change (fn [v]
                   (rf/dispatch [::events/set-mandatoriness-style v]))}]))

(defn show-question-ext-ids-selector
  [lang value]
  [labelled-input/view
   {:data-type :data.type/boolean
    :value     value
    :label     (loc/tr :show-questions-ext-ids? nil lang)
    :on-change (fn [v]
                 (rf/dispatch [::events/set-show-questions-ext-ids? v]))}])

(defn multi-survey-selector
  [lang value]
  [labelled-input/view
   {:data-type :data.type/boolean
    :value     value
    :label     (loc/tr :multi-survey? nil lang)
    :on-change (fn [v]
                 (rf/dispatch [::events/set-multi-survey? v]))}])

(defn hide-optional-selector
  [lang value]
  [labelled-input/view
   {:data-type :data.type/boolean
    :value     value
    :label     (loc/tr :hide-no-answer? nil lang)
    :on-change (fn [v]
                 (rf/dispatch [::events/set-hide-optional? v]))}])


(defn excel-info
  [lang use? text]
  [:<>
   [labelled-input/view
    {:data-type :data.type/boolean
     :value     use?
     :label     (loc/tr :show-excel-import?)
     :on-change (fn [v]
                  (rf/dispatch [::events/set-show-excel-import? v]))}]
   (when use?
     [labelled-input/view
      {:data-type :data.type/text-richtext
       :value     text
       :label     (loc/tr :survey-excel-info-text [(languages/get-label lang)])
       :on-change (fn [v]
                    (rf/dispatch [::events/set-excel-info-text lang v]))}])])
